import { ModelInputs } from "./types";

export const formatLabel = (k: string) =>
  k.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());

export const numOrUndef = (val: number | "") =>
  val === "" ? undefined : Number(val);

export const toIsoDateOrUndef = (d: string | "") =>
  d ? `${d}T00:00:00` : undefined;

export const prune = (obj: Record<string, unknown>) =>
  Object.fromEntries(
    Object.entries(obj).filter(
      ([, v]) =>
        v !== "" &&
        v !== null &&
        v !== undefined &&
        !(typeof v === "number" && Number.isNaN(v)) &&
        !(Array.isArray(v) && v.length === 0)
    )
  );

/** Shallow set helper for controlled inputs */
export function setField<T extends object>(
  setter: React.Dispatch<React.SetStateAction<T>>,
  name: keyof T,
  value: unknown
) {
  setter(prev => ({ ...prev, [name]: value } as T));
}
